import { useCallback } from 'react';
import { useRouter } from 'next/router';

export default () => {
  const router = useRouter();
  const queryParams = router.query;

  const getQuickResponseQueryParams = useCallback(() => {
    return {
      utmContentValue: queryParams.utm_content?.toString() || null,
      predictionValue: queryParams.prediction?.toString() || null,
    };
  }, [queryParams]);

  const removeQuickResponseQueryParams = useCallback(() => {
    delete router.query.utm_content;
    return router.replace({
      pathname: router.pathname,
      query: router.query,
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [router.query]);

  return {
    getQuickResponseQueryParams,
    removeQuickResponseQueryParams,
  };
};
